<div [formGroup]="form">
    <app-select-input
        id="user"
        [form]="form"
        [staticOptions]="users"
        [valueKey]="null"
        label="inputs.selectUser"
    >
        <ng-template #item let-item>
            <div class="flex-column gap-xx-small">
                <div>{{ item | formatPerson }}</div>
                @if (item.name?.length) {
                    <div class="font-size-x-small text-secondary">{{ item.email }}</div>
                }
            </div>
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ (item | formatPerson) || item.email }}
        </ng-template>
    </app-select-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        primaryButtonLabel="inputs.select"
        secondaryButtonLabel="inputs.itsNameMatch"
        (primaryClickEvent)="save($event)"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
